
import eventBus         from 'EventBus';
import BaseControlView from 'BaseControlView';
import constants        from 'Constants';
import template from 'report/control-data.ejs';
import util from 'util/Util.js';
import $ from "jquery";

const SILENT = constants.ACCESS_SILENT;

class DataControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-dropdown';

        this.listenTo(this.model, 'change', this.render);
        this.listenTo( eventBus, 'InputThemeChange', this.themeChangeRender);

        if (!util.hasEventListener(eventBus._events, constants.RESIZE_PROPERTIES_STYLE_PANEL)) {
            this.listenTo(eventBus, constants.RESIZE_PROPERTIES_STYLE_PANEL, util.resizeGridWidth);
        }

        return this;
    } 

    get kind() {
        return 'BaseStaticControl';
    }

    render(){
        this.model.set('normalRowBgColor', this.resolveThemeProp(this.model.get('normalRowBgColor')), SILENT);
        this.model.set('alternateRowBgColor', this.resolveThemeProp(this.model.get('alternateRowBgColor')), SILENT);
        super.render();
        util.resizeLastColumnOfAGivenGrid(this.model);
    }
}

export default DataControlView;
